// #366: the portal throttle's typed 429. Both server runtimes (the Netlify
// functions and the admin billing boundary) emit exactly this code + message,
// so a section whose only evidence is the error string can still recognise it.
export const PORTAL_RATE_LIMITED_CODE = 'rate_limited'
export const PORTAL_RATE_LIMITED_MESSAGE =
  'Too many requests. Please wait a moment and try again.'

export function isPortalRateLimited(value) {
  if (!value) return false
  if (typeof value === 'object') {
    return value.code === PORTAL_RATE_LIMITED_CODE
  }
  return String(value) === PORTAL_RATE_LIMITED_MESSAGE
}
